














import { Component, Vue } from 'vue-property-decorator'
import request, { Response } from '@/helpers/requests'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'
import TechTaskCard from '@/components/ui/TechTaskCard.vue'


interface RequestPayload {
    pulsemAccountId: number|null;
    isEnabled: boolean|null;
}


interface ResponsePayload extends Response {
    data: RequestPayload;
}


@Component({
    components: {
        AccountIdInput,
        TechTaskCard
    }
})
export default class GooglePlaceID extends Vue {
    locationValid = false
    pulsemAccountId: number|null = null
    isEnabled: boolean|null = null

    /**
     * The request payload that will be sent to the server.
     * @returns {Object}
     */
    get requestPayload(): RequestPayload {
        return {
            pulsemAccountId: this.pulsemAccountId,
            isEnabled: this.isEnabled
        }
    }

    /**
     * The text that will be displayed to CSMs, depending on whether the Web Chat is enabled or disabled.
     * @returns {string}
     */
    get toggleText(): string {
        return this.isEnabled ? 'Chat Widget is enabled, click toggle and submit to disable.' : 'Chat Widget is disabled, ' +
            'click toggle and submit to enable.'
    }

    /**
     * Loads the existing widget settings for the pulsemAccountId.
     * @returns {ResponsePayload}
     */
    async loadSettings(): Promise<ResponsePayload> {
        return await request.post('/support/widget-settings-load', {
            pulsemAccountId: this.pulsemAccountId
        }) as ResponsePayload
    }

    /**
     * If the location is valid, fetch the widget settings for the location else set isEnabled to null.
     * @param locationValid Whether the current location that was inputted is a valid location.
     */
    async onLocationChange(locationValid: boolean) {
        this.locationValid = locationValid
        if (this.locationValid) {
            const response = await this.loadSettings()
            this.isEnabled = response.data.isEnabled
        } else {
            this.isEnabled = null
        }
    }

    /**
     * If the request was executed successfully set the inputted values to null.
     * @param status The status of whether the request was executed successfully.
     */
    onSuccess(status: boolean) {
        if (status) {
            this.pulsemAccountId = null
            this.isEnabled = null
        }
    }
}
